import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Line} from 'react-chartjs-2';


const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'], // Sample data overwritten later
    datasets: [
        {
            label: 'New tickets',
            fill: true,
            lineTension: 0.1,
            backgroundColor: 'rgba(255, 206, 86,0.2)',
            borderColor: 'rgba(255, 206, 86,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(255, 206, 86,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(255, 206, 86,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [65, 59, 80, 81, 56, 55, 40]
        },
        {
            label: 'Solved tickets',
            fill: true,
            lineTension: 0.1,
            backgroundColor: 'rgba(54, 162, 235,0.2)',
            borderColor: 'rgba(54, 162, 235,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(54, 162, 235,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(54, 162, 235,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [25, 30, 70, 90, 40, 40, 20]
        }

    ]
};

@injectIntl @inject('analyticsStore') @observer
export default class NewAndSolvedTicketsPlot extends React.Component{
    render() {
        const {intl, analyticsStore} = this.props;
        if( analyticsStore.loading ){
            return(
                <div className='text-center'>
                    <div className="main-loader">
                        <div className="loader-lg"></div>
                    </div>
                    <span>{intl.formatMessage({id: 'loading'})}</span>
                </div>
            );
        }

        //  New tickets
        data.datasets[0].label = intl.formatMessage({id: 'new_tickets_plot_label'});
        data.datasets[0].data = analyticsStore.newTicketsValues;

        // Solved tickets
        data.datasets[1].label = intl.formatMessage({id: 'solved_tickets_plot_label'});
        data.datasets[1].data = analyticsStore.solvedTicketsValues;

        // Dates labels
        data.labels = analyticsStore.newTicketsKeys;
        
        // Options 
        const options = {
                maintainAspectRatio: false, 
            }
        return <div style={{overflowX: 'auto'}}>
                    <div style={ {minWidth: '700px', minHeight: '500px'} }>
                        <Line data={data}
                            options={options} />
                    </div>
            </div>;
    }
};